import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../common/components/button/button.component';
import { FILE_NAME_CANCEL, FILE_NAME_CONFIRM, EMPTY_STRING } from '../../../../constants/constants';
import './invalid-name-confirmation.style.scss';
/**
 * Class representing file name confirmation popup component.
 * @extends Component
 * */

class InvalidNameConfirmation extends Component {

  /**
   * Calls the confirmation callback.
   * */
  confirm = () => {
    const { onConfirm } = this.props;
    onConfirm();
  };

  /**
   * Calls the cancel callback.
   * */
  cancel = () => {
    const { onCancel } = this.props;
    onCancel();
  };

  render() {
    const { message, isVisible } = this.props;

    if (message && isVisible) {
      return (
        <div className="invalid-name-confirmation">
          <div className="confirmation-background container" />
          <div className="popup container">
            <div className="message">
              <div className="messageRow"><strong>The name you have selected is already in use or contains invalid characters.</strong> <br />Please enter a unique name with letters and numbers only.
              </div>
              <div className="messageRow">If you prefer, we will rename it for you using the name
                <span className="suggestedName">  {message}</span>
              </div>
            </div>
            <div className="actions">
              <Button
                buttonClass="btn btn-success btn-block"
                onButtonClick={this.confirm}
                title={FILE_NAME_CONFIRM}
              />
              <Button
                buttonClass="btn btn-secondary btn-block"
                onButtonClick={this.cancel}
                title={FILE_NAME_CANCEL}
              />
            </div>
          </div>
        </div>
      );
    }

    return null;
  }

}

export default InvalidNameConfirmation;

InvalidNameConfirmation.propTypes = {
  isVisible: PropTypes.bool,
  message: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,

};

InvalidNameConfirmation.defaultProps = {
  isVisible: false,
  message: EMPTY_STRING
};



// WEBPACK FOOTER //
// ./src/messages/dashboard/file-details/invalid-name-confirmation/invalid-name-confirmation.component.js